export default __webpack_public_path__ + "static/media/pactwithset.e9b086dc.png";